import * as React from 'react';
import { endOfMonth, format, parse, startOfMonth } from 'date-fns';
import { DateRange, GeneralLedgerFilters, SidebarDescriptor } from 'general-ledger/types';
import { NewGeneralLedger } from './NewGeneralLedger';
import SelectDateRangeNullState from 'general-ledger/SelectDateRangeNullState';

const dateFormat = 'YYYY-MM-DD';

const expandDateRangeToSpanWholeMonths = (dateRange: DateRange): DateRange => {
  const endDateAtEndOfMonth =
    dateRange && dateRange.endDate && format(endOfMonth(parse(dateRange.endDate)), dateFormat);
  const startDateAtStartOfMonth =
    dateRange &&
    dateRange.startDate &&
    format(startOfMonth(parse(dateRange.startDate)), dateFormat);
  return {
    endDate: endDateAtEndOfMonth,
    startDate: startDateAtStartOfMonth,
  };
};

type GeneralLedgerContainerProps = {
  clientId: string;
  dateRange?: DateRange;
  filters: GeneralLedgerFilters;
  updateQueryParams: (obj: Record<string, unknown>) => any;
  updateSidebarParams: (obj?: Record<string, unknown>) => any;
  sidebarDescriptor?: SidebarDescriptor;
};

export const NewGeneralLedgerContainer = ({
  clientId,
  dateRange,
  filters,
  updateQueryParams,
  updateSidebarParams,
  sidebarDescriptor,
}: GeneralLedgerContainerProps): React.ReactElement => {
  const fullDateRange = dateRange && expandDateRangeToSpanWholeMonths(dateRange);

  if (!fullDateRange || !fullDateRange.startDate || !fullDateRange.endDate) {
    return <SelectDateRangeNullState updateDateRange={updateQueryParams} />;
  }

  return (
    <NewGeneralLedger
      clientId={clientId}
      dateRange={fullDateRange}
      filters={filters}
      updateQueryParams={updateQueryParams}
    />
  );
};
